import { NmeaConfigField } from "./NmeaConfigField"

// BUG-082 (glimpse v2 RG-SUP-250 / RG-ADM-233) - trames masquées quand elles sont plus anciennes
// que la SEAMRS du cycle si l'option `hideIfOlderThanMrs` n'est pas posée (réglée dans l'admin v2).
export const NMEA_HIDE_IF_OLDER_THAN_MRS_DEFAULT = ['seawpt', 'seadrf', 'seatrk', 'seaflt', 'seabtm', 'seadev', 'seaalr']

/** Option effective d'une trame : celle de la config si posée, sinon le défaut par nom (jamais la SEAMRS). */
export const mustHideIfOlderThanMrs = (config?: { name?: string, hideIfOlderThanMrs?: boolean }) => {
    const name = (config?.name ?? '').toLowerCase()
    if (!name || name == 'seamrs') return false
    if (typeof config?.hideIfOlderThanMrs === 'boolean') return config.hideIfOlderThanMrs
    return NMEA_HIDE_IF_OLDER_THAN_MRS_DEFAULT.indexOf(name) >= 0
}

export class NmeaConfig {
        
    public name:string            
    public colHidden:Array<NmeaConfigField>
    public col1:Array<NmeaConfigField>
    public col2:Array<NmeaConfigField>
    public col3:Array<NmeaConfigField>
    // BUG-082 - option posée par l'admin v2 : conservée pour que l'enregistrement v1 ne la perde pas
    public hideIfOlderThanMrs?:boolean

    constructor({name = '', col1=[], col2=[],col3=[],colHidden=[], hideIfOlderThanMrs = undefined as boolean | undefined} = {}) {
        this.name = name        
        this.colHidden = colHidden.map(c => new NmeaConfigField(c))
        this.col1 = col1.map(c => new NmeaConfigField(c))
        this.col2 = col2.map(c => new NmeaConfigField(c))
        this.col3 = col3.map(c => new NmeaConfigField(c))
        if (typeof hideIfOlderThanMrs === 'boolean') this.hideIfOlderThanMrs = hideIfOlderThanMrs
    }    
}
